import React from "react";
import { Languages } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const labels = {
  en: { title: "Language", aria: "Select language" },
  es: { title: "Idioma", aria: "Seleccionar idioma" },
  zh: { title: "语言", aria: "选择语言" },
};

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();
  const copy = labels[language];

  return (
    <div
      data-i18n-ignore
      className="fixed right-3 bottom-3 md:bottom-auto md:top-20 z-[100] flex items-center gap-2 rounded-md border border-zinc-300 bg-white/95 px-3 py-2 text-zinc-950 shadow-lg backdrop-blur"
      data-testid="language-switcher"
    >
      <Languages size={18} className="shrink-0 text-amber-600" aria-hidden="true" />
      <label htmlFor="app-language" className="hidden sm:block text-xs font-bold uppercase tracking-wider">
        {copy.title}
      </label>
      <select
        id="app-language"
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        aria-label={copy.aria}
        className="cursor-pointer bg-transparent text-sm font-semibold outline-none"
      >
        <option value="en">English</option>
        <option value="es">Español</option>
        <option value="zh">中文</option>
      </select>
    </div>
  );
}

